import React from "react";
import {
  Box,
  Text,
  Heading,
  Grid,
  GridItem,
  NumberInput,
  NumberInputField,
  Image,
  // Slider,
  // SliderMark,
  // SliderTrack,
  // SliderFilledTrack,
  // SliderThumb,
  Divider,
  // Tooltip,
  HStack,
  useRadio,
  Link,
  Button,
} from "@chakra-ui/react";
import { CheckCircleIcon, QuestionOutlineIcon } from "@chakra-ui/icons";
import { chakra } from "@chakra-ui/react";
import styled from "@emotion/styled";
import _Card from "./Card/Card";
import OpBWSModal from "./OpBWSModal";
import RiskTradeOffModal from "./RiskTradeOffModal";
import RiskObjectiveButtonGroup from "./RiskObjectiveButtonGroup";

const AVAX = "avax";
const SOL = "sol";
const LUNA = "luna";
const NEAR = "near";
const DOPEX = "dopex";
const DEBRIT = "debrit";

const _GradientCard = styled(Box)`
  display: flex;
  background: linear-gradient(359.05deg, #3e3e3e 0.72%, #04a7f0 99.1%);
  padding: 2px;
  box-shadow: rgb(0 0 0 / 5%) 0px 6px 10px;
  border-radius: 6px;
`;

const GradientCard = chakra(_GradientCard);

const RadioCard = (props) => {
  const { getInputProps, getCheckboxProps } = useRadio(props);
  const input = getInputProps();
  const checkbox = getCheckboxProps();

  return (
    <Box as="label">
      <input {...input} />
      <Box
        {...checkbox}
        display="flex"
        cursor="pointer"
        boxShadow="md"
        fontSize="lg"
        border="2px solid rgb(140, 140, 227)"
        borderRadius="6px"
        alignItems="center"
        background="black"
        color="white"
        _checked={{
          bg: "rgb(140, 140, 227)",
          color: "black",
          borderColor: "teal.600",
        }}
        _hover={{
          border: "2px solid rgba(140, 140, 227, 0.5)",
        }}
        _focus={{
          boxShadow: "outline",
        }}
        px={3}
        pl={2}
        pr={4}
      >
        {props.children}
      </Box>
    </Box>
  );
};

const GoodBridging = () => {
  // const [sliderValue, setSliderValue] = React.useState(10);
  // const [showTooltip, setShowTooltip] = React.useState(false);
  const [universe, setUniverse] = React.useState(AVAX);
  const [constraints, setConstraints] = React.useState(DOPEX);
  const [isOpBwsOpen, setIsOpBwsOpen] = React.useState(false);
  const [isTradeOffModalOpen, setTradeOffModalOpen] = React.useState(false);

  return (
    <Box py={10}>
      <Heading as="h2" size="xl" color="rgb(140, 140, 227)" mb={3}>
        Good Bridging
      </Heading>
      {/* <Text fontSize="lg" color="white" mb={3}>
        {
          "Tell us your asset exposure to ETH. We will cover your position's protection."
        }
      </Text> */}

      <GradientCard flexDirection="row" style={{ height: "auto!importand" }}>
        <Box flex="1" background="rgb(30, 29, 45)" borderRadius="6px" p={5}>
          <Grid templateColumns="repeat(5, 1fr)" gap={4}>
            <GridItem colSpan={1} alignItems="center">
              <Text fontSize="lg" color="white" mb={3} fontWeight="700" mx={3}>
                Current ETH holding
              </Text>
            </GridItem>
            <GridItem colSpan={4}>
              <NumberInput
                defaultValue={10}
                precision={18}
                min={10}
                color="white"
                fontSize="2xl"
              >
                <NumberInputField />
              </NumberInput>
              <Text fontSize="lg" color="white" mt={3}>
                Minimum 10 ETH to join the vault
              </Text>
            </GridItem>
          </Grid>

          <Divider my={5} />

          <Grid templateColumns="repeat(5, 1fr)" gap={4}>
            <GridItem colSpan={1} alignItems="center">
              <Box
                style={{
                  display: "inline-flex!important",
                  width: "252px",
                }}
                mb={5}
              >
                <Box borderRadius="6px" p={3} width="100%">
                  <Text fontSize="lg" color="white" mb={3} fontWeight="700">
                    Bridge Your Asset here
                  </Text>
                  <Divider mb={3} />
                  <Text
                    fontSize="2xl"
                    fontWeight="700"
                    textTransform="uppercase"
                    mb={2}
                    style={{
                      background:
                        "-webkit-linear-gradient(90deg, #0072ff 0%, #00d4ff 100%)",
                      "-webkit-background-clip": "text",
                      "-webkit-text-fill-color": "transparent",
                    }}
                  >
                    Deposit Now
                  </Text>
                  <Text color="rgba(255,255,255,0.7)" fontSize="lg" mb={3}>
                    To enjoy <span>AVAX + opBWS</span> double rewarding!
                  </Text>
                  <Box
                    borderRadius="6px"
                    background="rgb(39, 37, 64)"
                    display="inline-flex"
                    p={3}
                    height="42px"
                    justifyContent="center"
                    alignItems="center"
                    cursor="pointer"
                    onClick={() => setIsOpBwsOpen(true)}
                  >
                    <Text
                      fontSize="md"
                      color="rgb(96 165 250)"
                      display="inline-flex"
                      alignItems="center"
                    >
                      What is opBWS?
                    </Text>
                    <OpBWSModal
                      isOpen={isOpBwsOpen}
                      onClose={() => setIsOpBwsOpen(false)}
                    />
                  </Box>
                </Box>
              </Box>
            </GridItem>

            <GridItem colSpan={4}>
              <Box display="flex" flexDirection="space-between">
                <Link href="https://bridge.avax.network/" isExternal>
                  <Box
                    border="2px solid rgb(140, 140, 227)"
                    borderRadius="6px"
                    background="black"
                    display="inline-flex"
                    mb={3}
                    p={3}
                    maxHeight="52px"
                    _hover={{
                      border: "2px solid rgba(140, 140, 227, 0.5)",
                    }}
                  >
                    <Image
                      src="./assets/avalanche-bridge-logo.svg"
                      height="24px"
                      alt="Avax Bridge"
                      margin="0 auto"
                    />
                  </Box>
                </Link>
              </Box>
              {/* <Text fontSize="lg" color="white" mb={3}>
                <span>
                  If your asset haven't expose to <b>AVAX, LUNA, SOLANA</b>.
                  Bridge Your Asset here
                </span>
              </Text> */}
            </GridItem>
          </Grid>

          <Divider my={5} />

          <Grid templateColumns="repeat(5, 1fr)" gap={4}>
            <GridItem colSpan={1} alignItems="center">
              <Text fontSize="lg" color="white" mb={3} fontWeight="700" mx={3}>
                Goal
              </Text>
              <Text fontSize="lg" color="white" mb={3} mx={3}>
                What's Your Objective
              </Text>
            </GridItem>

            <GridItem colSpan={4} display="flex" flexDirection="column">
              <Box py={3} width="100%">
                <RiskObjectiveButtonGroup />
                <QuestionOutlineIcon
                  color="#efefef"
                  w={6}
                  h={6}
                  ml={3}
                  borderRadius="50%"
                  cursor="pointer"
                  onClick={() => setTradeOffModalOpen(true)}
                />
                <RiskTradeOffModal
                  isOpen={isTradeOffModalOpen}
                  onClose={() => setTradeOffModalOpen(false)}
                />
              </Box>
              <Box display="flex" alignItems="center">
                <Text fontSize="lg" color="white">
                  Exposure while keeping same upside, power by
                </Text>

                <Link href="https://www.dopex.io/" isExternal>
                  <Box
                    borderRadius="6px"
                    background="rgba(0,0,0,0.3)"
                    display="inline-flex"
                    m={3}
                    pr={5}
                    height="48px"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Image
                      p={5}
                      src="./assets/DopexLogo.svg"
                      width="64px"
                      alt="Dopex"
                      margin="0 auto"
                    />
                    <Text
                      fontSize="lg"
                      color="rgb(96 165 250)"
                      display="inline-flex"
                      alignItems="center"
                    >
                      Dopex
                    </Text>
                  </Box>
                </Link>
              </Box>
            </GridItem>
          </Grid>

          <Divider my={5} />

          <Grid templateColumns="repeat(5, 1fr)" gap={4}>
            <GridItem colSpan={1} alignItems="center">
              <Text fontSize="lg" color="white" mb={3} fontWeight="700" mx={3}>
                Trade Universe
              </Text>
            </GridItem>

            <GridItem colSpan={4} display="flex" flexDirection="column">
              <Box py={3} width="100%" color="white">
                <HStack>
                  <RadioCard
                    key={AVAX}
                    size="lg"
                    name={AVAX}
                    colorScheme="orange"
                    isChecked={universe === AVAX}
                    onChange={() => setUniverse(AVAX)}
                  >
                    <Image
                      src="./assets/avax.png"
                      width="48px"
                      height="48px"
                      alt="Near Logo"
                      margin="0 auto"
                      fill="white"
                      p={3}
                    />
                    <Text>Avalanche</Text>
                  </RadioCard>

                  <RadioCard
                    key={LUNA}
                    size="lg"
                    name={LUNA}
                    colorScheme="orange"
                    isChecked={universe === LUNA}
                    onChange={() => setUniverse(LUNA)}
                  >
                    <Image
                      src="./assets/terra-luna-luna-logo.png"
                      width="48px"
                      height="48px"
                      alt="Near Logo"
                      margin="0 auto"
                      fill="white"
                      p={3}
                    />
                    <Text>Luna (Coming Soon)</Text>
                  </RadioCard>
                  <RadioCard
                    key={SOL}
                    size="lg"
                    name={SOL}
                    colorScheme="orange"
                    isChecked={universe === SOL}
                    onChange={() => setUniverse(SOL)}
                  >
                    <Image
                      src="./assets/solanaLogoMark.svg"
                      width="48px"
                      height="48px"
                      alt="Near Logo"
                      margin="0 auto"
                      fill="white"
                      p={3}
                    />
                    <Text>Solana (Coming Soon)</Text>
                  </RadioCard>

                  <RadioCard
                    key={NEAR}
                    size="lg"
                    name={NEAR}
                    colorScheme="orange"
                    isChecked={universe === NEAR}
                    onChange={() => setUniverse(NEAR)}
                  >
                    <Image
                      src="./assets/near_icon_wht.png"
                      width="48px"
                      alt="Near Logo"
                      margin="0 auto"
                      fill="white"
                    />
                    <Text>NEAR (Coming Soon)</Text>
                  </RadioCard>
                </HStack>
              </Box>

              <Box display="flex" alignItems="center" pt={3}>
                <Text fontSize="lg" color="white">
                  See the set of assets in the Selected Universe.
                </Text>

                <Link
                  href="https://www.bondiwealthsecurity.xyz/analytics"
                  isExternal
                >
                  <Box
                    borderRadius="6px"
                    background="rgba(0,0,0,0.3)"
                    display="inline-flex"
                    m={3}
                    p={5}
                    height="48px"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Text
                      fontSize="lg"
                      color="rgb(96 165 250)"
                      display="inline-flex"
                      alignItems="center"
                    >
                      HERE
                    </Text>
                  </Box>
                </Link>
              </Box>
            </GridItem>
          </Grid>

          <Divider my={5} />

          <Grid templateColumns="repeat(5, 1fr)" gap={4}>
            <GridItem colSpan={1} alignItems="center">
              <Text fontSize="lg" color="white" mb={3} fontWeight="700" mx={3}>
                Constraints
              </Text>
            </GridItem>

            <GridItem colSpan={4}>
              <Box display="flex" gap={5}>
                <Box display="flex" flexDirection="column">
                  <Box
                    cursor="pointer"
                    border="2px solid rgb(140, 140, 227)"
                    borderRadius="6px"
                    background="black"
                    display="inline-flex"
                    mb={3}
                    p={3}
                    _hover={{
                      border: "2px solid rgba(140, 140, 227, 0.5)",
                    }}
                    onClick={() => setConstraints(DOPEX)}
                    position="relative"
                  >
                    <Image
                      src="./assets/DopexLogo.svg"
                      width="24px"
                      alt="Dopex"
                      margin="0 auto"
                    />
                    <Text
                      fontSize="lg"
                      color="white"
                      display="inline-flex"
                      alignItems="center"
                      pr="5"
                      fontWeight="700"
                    >
                      Dopex
                    </Text>
                    {constraints === DOPEX ? (
                      <CheckCircleIcon
                        color="#21bf96"
                        w={6}
                        h={6}
                        position="absolute"
                        right="-12px"
                        top="-12px"
                        background="white"
                        borderRadius="50%"
                      />
                    ) : null}
                  </Box>
                  <Text fontSize="lg" color="white" mb={3}>
                    Short Term Upside
                  </Text>
                </Box>
                <Box display="flex" flexDirection="column">
                  <Box
                    cursor="pointer"
                    border="2px solid rgb(140, 140, 227)"
                    borderRadius="6px"
                    background="black"
                    display="inline-flex"
                    mb={3}
                    p={3}
                    _hover={{
                      border: "2px solid rgba(140, 140, 227, 0.5)",
                    }}
                    onClick={() => setConstraints(DEBRIT)}
                    position="relative"
                  >
                    <Image
                      src="./assets/logo-deribit.svg"
                      height="26px"
                      alt="DEBRIT"
                      margin="0 auto"
                    />
                    {constraints === DEBRIT ? (
                      <CheckCircleIcon
                        color="#21bf96"
                        w={6}
                        h={6}
                        position="absolute"
                        right="-12px"
                        top="-12px"
                        background="white"
                        borderRadius="50%"
                      />
                    ) : null}
                  </Box>
                  <Text fontSize="lg" color="white" mb={3}>
                    Long Term Upside
                  </Text>
                </Box>
              </Box>
            </GridItem>
          </Grid>
        </Box>
      </GradientCard>
      <Box
        display="flex"
        width="100%"
        flexDirection="column"
        justifyContent="center"
        gap="3"
        alignItems="center"
        mt={7}
      >
        <Button
          background="#21bf96"
          size="lg"
          transition="all 0.2s cubic-bezier(.08,.52,.52,1)"
          width="360px"
        >
          Optimize
        </Button>
        <Text
          fontSize="xl"
          mb={1}
          width="75%"
          textAlign="center"
          style={{
            background:
              "-webkit-linear-gradient(90deg, #00ff37 0%, #00d4ff 100%)",
            "-webkit-background-clip": "text",
            "-webkit-text-fill-color": "transparent",
          }}
        >
          The PnL of the vaults is denominated in <b>WETH.e</b> assets, to match
          their goal being to{" "}
          <b>
            accumulate more WETH.e over time, but enjoy AVAX cheap transaction
            cost.
          </b>
        </Text>
      </Box>
    </Box>
  );
};

export default GoodBridging;
